"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBank = exports.BankNameExistByCardNumber = exports.getBankNameByCardNumber = exports.getBankNameByShaba = exports.shabaToBank = exports.cardNumberToBank = exports.BankNames = void 0;
const numbers_1 = require("./numbers");
var BankNames;
(function (BankNames) {
    BankNames["TOSEE_SADERAT"] = "tosee_saderat";
    BankNames["PASARGAD"] = "pasargad";
    BankNames["SHAHR"] = "shahr";
    BankNames["TOSEE_TAAVON"] = "tosee_taavon";
    BankNames["KARAFARIN"] = "karafarin";
    BankNames["DEY"] = "dey";
    BankNames["RESALAT"] = "resalat";
    BankNames["GARDESHGARI"] = "gardeshgari";
    BankNames["IRANZAMIN"] = "iranzamin";
    BankNames["NOOR"] = "noor";
    BankNames["KHAVARMIANEH"] = "khavarmianeh";
    BankNames["TEJARAT"] = "tejarat";
    BankNames["SEPAH"] = "sepah";
    BankNames["REFAH"] = "refah";
    BankNames["SADERAT"] = "saderat";
    BankNames["KESHAVARZI"] = "keshavarzi";
    BankNames["MELLI"] = "melli";
    BankNames["MELALL"] = "melall";
    BankNames["MEHR_IRAN"] = "mehr_iran";
    BankNames["MELLAT"] = "mellat";
    BankNames["SAMAN"] = "saman";
    BankNames["PARSIAN"] = "parsian";
    BankNames["EGHTESAD_NOVIN"] = "eghtesad_novin";
    BankNames["POSTBANK"] = "postbank";
    BankNames["SANAT_MADAN"] = "sanat_madan";
    BankNames["MASKAN"] = "maskan";
    BankNames["TOSEE"] = "tosee";
    BankNames["AYANDEH"] = "ayandeh";
    BankNames["MARKAZI"] = "markazi";
    BankNames["SINA"] = "sina";
    BankNames["SARMAYEH"] = "sarmayeh";
    BankNames["NONE"] = "none";
})(BankNames || (exports.BankNames = BankNames = {}));
exports.cardNumberToBank = {
    "207177": BankNames.TOSEE_SADERAT,
    "627648": BankNames.TOSEE_SADERAT,
    "502229": BankNames.PASARGAD,
    "639347": BankNames.PASARGAD,
    "502806": BankNames.SHAHR,
    "504706": BankNames.SHAHR,
    "502908": BankNames.TOSEE_TAAVON,
    "502910": BankNames.KARAFARIN,
    "627488": BankNames.KARAFARIN,
    "502938": BankNames.DEY,
    "504172": BankNames.RESALAT,
    "505416": BankNames.GARDESHGARI,
    "505785": BankNames.IRANZAMIN,
    "507677": BankNames.NOOR,
    "585947": BankNames.KHAVARMIANEH,
    "585983": BankNames.TEJARAT,
    "627353": BankNames.TEJARAT,
    "589210": BankNames.SEPAH,
    "505801": BankNames.SEPAH,
    "627381": BankNames.SEPAH,
    "636949": BankNames.SEPAH,
    "639370": BankNames.SEPAH,
    "639599": BankNames.SEPAH,
    "589463": BankNames.REFAH,
    "603769": BankNames.SADERAT,
    "603770": BankNames.KESHAVARZI,
    "639217": BankNames.KESHAVARZI,
    "603799": BankNames.MELLI,
    "606256": BankNames.MELALL,
    "606373": BankNames.MEHR_IRAN,
    "610433": BankNames.MELLAT,
    "991975": BankNames.MELLAT,
    "621986": BankNames.SAMAN,
    "622106": BankNames.PARSIAN,
    "627884": BankNames.PARSIAN,
    "639194": BankNames.PARSIAN,
    "627412": BankNames.EGHTESAD_NOVIN,
    "627760": BankNames.POSTBANK,
    "627961": BankNames.SANAT_MADAN,
    "628023": BankNames.MASKAN,
    "628157": BankNames.TOSEE,
    "636214": BankNames.AYANDEH,
    "636795": BankNames.MARKAZI,
    "639346": BankNames.SINA,
    "639607": BankNames.SARMAYEH,
};
exports.shabaToBank = {
    "017": BankNames.MELLI,
    "012": BankNames.MELLAT,
    "015": BankNames.SEPAH,
    "018": BankNames.TEJARAT,
    "055": BankNames.EGHTESAD_NOVIN,
    "059": BankNames.SINA,
    "020": BankNames.TOSEE_SADERAT,
    "016": BankNames.KESHAVARZI,
    "019": BankNames.SADERAT,
    "014": BankNames.MASKAN,
    "054": BankNames.PARSIAN,
    "062": BankNames.AYANDEH,
    "010": BankNames.MARKAZI,
    "053": BankNames.KARAFARIN,
    "011": BankNames.SANAT_MADAN,
    "058": BankNames.SARMAYEH,
    "056": BankNames.SAMAN,
    "013": BankNames.REFAH,
    "051": BankNames.TOSEE,
    "021": BankNames.POSTBANK,
    "057": BankNames.PASARGAD,
};
const getBankNameByShaba = (shaba) => {
    var _a;
    const bankCode = shaba.slice(2, 5);
    return (_a = exports.shabaToBank[bankCode]) !== null && _a !== void 0 ? _a : BankNames.NONE;
};
exports.getBankNameByShaba = getBankNameByShaba;
const getBankNameByCardNumber = (cardNumber) => {
    var _a;
    const bankCode = (0, numbers_1.digitsToLatin)(cardNumber.replace(" ", "")).slice(0, 6);
    return (_a = exports.cardNumberToBank[bankCode]) !== null && _a !== void 0 ? _a : BankNames.NONE;
};
exports.getBankNameByCardNumber = getBankNameByCardNumber;
const BankNameExistByCardNumber = (cardNumber) => {
    const bankCode = (0, numbers_1.digitsToLatin)(cardNumber.replace(" ", "")).slice(0, 6);
    return exports.cardNumberToBank[bankCode] ? true : false;
};
exports.BankNameExistByCardNumber = BankNameExistByCardNumber;
const useBank = () => {
    return {
        getBankNameByCardNumber: exports.getBankNameByCardNumber,
        getBankNameByShaba: exports.getBankNameByShaba,
        BankNameExistByCardNumber: exports.BankNameExistByCardNumber,
    };
};
exports.useBank = useBank;
//# sourceMappingURL=bank.js.map